<template>
  <div class="about">
    <div class="about-l">
      <div class="about-l-top">
        <p>ABOUT US</p>
        <p>关于我们</p>
      </div>
      <div class="about-l-menu">
        <p class="about-l-menu-item">关于我们</p>
        <!-- <div class="info-div">
          <div class="info-div-title">
            <i class="el-icon-phone"></i>
            <span>服务热线</span>
          </div>
          <p class="info-div-phone">0571-88026052</p>
          <div class="info-div-content">
            <p> 地址：容桂龙涌口村委会新龙工业区4号首层之二 </p>
            <p> 手机：13000000XXX </p>
            <p> 电话：0777-2361XXX </p>
            <p> 邮箱：1270XXXX@qq.com </p>
          </div>

        </div> -->
      </div>
    </div>
    <div class="about-r">
      <div class="about-r-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于我们</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="contact-box">
          <p class="p-title">公司简介 PROFILE​</p>
          <p class="p-content">万博云信（北京)教育科技有限公司2015年成立于北京，国家高新技术企业，公司由国内职业教育专家和互联网资深人士组建，先后获得多轮机构投资，是国内领先的实习实训信息化管理服务商，在全国各地设有10多个办事处。公司始终专注于提供院校学生实习、就业跟踪、校企合作等整体解决方案，产品“习讯云”利用领先的云计算、移动互联网和大数据技术，实现院校实习管理、就业跟踪、校企合作、实践教学管理、实验实训管理业务流程化、智能化、精细化和数据化，产品先后在全国高职高专校长联席会议、全国中职校长联席会议、全国技工院校校长论坛等全国性会议进行推荐宣传，目前公司已合作院校数百家，是全国具有省级实习管理平台和市级实习管理平台建设运营案例的服务商！</p>
          <!-- <p class="p-title">发展历程 DEVELOPMENT HISTORY</p> -->
          <!-- <p>联 系 人：陈先生</p> -->
          <!-- <p>公司邮箱：lijie@vanber.cn</p> -->
          <!-- <p>公司传真：020-6668XXXX</p> -->
          <!-- <p>邮政编码：100000</p> -->
          <!-- <p>公司地址：北京市海淀区苏州街3号 / 浙江省杭州市学府街515号智慧谷803</p> -->
          <div>

          </div>
        </div>
        <!-- <div id="companyAddress">

        </div> -->
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Swipe from './swipe.vue';
// import Content from './Contentt.vue';
import loadBMap from '../assets/js/loadBMap.js';

export default {
  name: 'Home',
  data() {
    return {
      proList: [],
      mapId: 'BMap-' + parseInt(Date.now() + Math.random()),
      myMap: null,
    };
  },
  components: {},
  created() {
    // if (!this.$store.state.token) {
    //   this.$router.push({
    //     path: '/login'
    //   });
    // }
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.initMap();
  },
  methods: {
    async getProvince() {
      let result = await this.$api.instance.getProvince();
      console.log(result);
    },
    async getEducation() {
      let result = await this.$api.instance.getEducation();
      console.log(result);
    },
    async getStudentApply() {
      let params = {
        page: 1,
        size: 100,
      };
      let result = await this.$api.instance.getStudentApply(params);
      console.log(result);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-breadcrumb {
  font-size: 15px;
  padding: 0 0 16px;
  border-bottom: 1px solid #a5a3a35c;
}
.about {
  width: 1200px;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  .about-l {
    width: 20%;
    &-top {
      height: 152px;
      background-image: url('../assets/image/xt_bg.jpg');
      position: relative;
      margin-top: -80px;
      z-index: 2;
      color: #fefefe;
      p:first-child {
        font-size: 20px;
        padding-top: 48px;
      }
      p:last-child {
        font-size: 26px;
        font-weight: bold;
        margin-top: 2px;
      }
    }
    &-menu {
      .info-div {
        margin-top: 4px;
        // height: 220px;
        border: 1px solid #7ba6f51f;
        background: #f1f1f7;
        text-align: left;
        padding: 16px 16px 32px;
        &-title {
          height: 24px;
          line-height: 24px;
          i {
            padding: 2px;
            border: 1px solid #71a2fe;
            color: #7aa6ff;
            border-radius: 14px;
            font-size: 18px;
            margin-right: 8px;
          }
          span {
            vertical-align: top;
            font-size: 15px;
            color: #4b4b4c;
          }
        }
        &-phone {
          font-size: 24px;
          margin-top: 8px;
          color: #6e9cfe;
          font-weight: bold;
          letter-spacing: 1.5px;
        }
        &-content {
          font-size: 12px;
          color: #4b4b4c;
          padding-top: 16px;
          margin-top: 16px;
          border-top: 1px dashed #7ba6f51f;
          p + p {
            margin-top: 8px;
          }
        }
      }
      &-item {
        cursor: pointer;
        margin-top: 2px;
        padding: 16px;
        background: #a2c2fd;
        color: #fff;
      }
      &-item:hover {
        background: #3d86e0;
      }
    }
  }
  .about-r {
    width: 80%;
    &-box {
      padding: 24px;
      height: calc(100% - 48px);
      .contact-box {
        padding: 16px;
        // background: url('../assets/image/contact_bgx.jpg');
        height: 252px;
        background-position: 55%;
        // margin-top: 24px;
        text-align: left;
        color: #666;
        // font-size: 14px;
        letter-spacing: 1.5px;
        .p-title {
          margin-top: 8px;
          margin-bottom: 8px;
          font-size: 15px;
          color: #333;
          font-weight: bold;
        }
        .p-content {
          text-indent: 24px;
          font-size: 15px;
          line-height: 32px;
        }
        p {
          margin-top: 4px;
          color: #3e3d3d;
        }
      }
      #companyAddress {
        height: 380px;
        border: 1px dashed #ccc;
      }
    }
  }
  // background: #acbfa8;
}
</style>
